var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4578 1.59133C17.9691 1.08683 17.3889 0.686629 16.7503 0.413583C16.1117 0.140537 15.4272 0 14.7359 0C14.0446 0 13.3601 0.140537 12.7215 0.413583C12.0829 0.686629 11.5026 1.08683 11.0139 1.59133C10.459 2.16392 9.54045 2.16392 8.98554 1.59133C7.99842 0.572757 6.6596 0.000527962 5.26361 0.000527973C3.86761 0.000527984 2.52879 0.572757 1.54168 1.59133C0.554557 2.6099 1.0401e-08 3.99139 0 5.43187C-1.0401e-08 6.87235 0.554557 8.25383 1.54168 9.2724L2.55588 10.3189L8.56353 16.518C9.34934 17.3289 10.6502 17.3289 11.436 16.518L17.4436 10.3189L18.4578 9.2724C18.9467 8.76814 19.3346 8.16942 19.5992 7.51045C19.8638 6.85148 20 6.14517 20 5.43187C20 4.71857 19.8638 4.01225 19.5992 3.35328C19.3346 2.69431 18.9467 2.09559 18.4578 1.59133Z",
    fill: "url(#paint0_radial_1_1895)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.373 1.9393L11.3731 1.93921C11.8161 1.48188 12.3412 1.11995 12.9181 0.873325C13.4948 0.626713 14.1125 0.5 14.7359 0.5C15.3593 0.5 15.9769 0.626712 16.5537 0.873325C17.1305 1.11995 17.6557 1.48188 18.0987 1.93921L18.0988 1.93938C18.5421 2.39653 18.8945 2.94016 19.1352 3.5396C19.3759 4.13906 19.5 4.78211 19.5 5.43187C19.5 6.08163 19.3759 6.72467 19.1352 7.32413C18.8945 7.92357 18.5421 8.46721 18.0988 8.92435L18.0988 8.92444L17.0846 9.97096L11.0769 16.1701C10.4876 16.7782 9.51194 16.7782 8.92258 16.1701L2.91493 9.97096L1.90073 8.92444C1.00557 8.00075 0.5 6.74471 0.5 5.43187C0.5 4.11902 1.00557 2.86298 1.90073 1.9393C2.79537 1.01614 4.00537 0.500528 5.26361 0.500528C6.52184 0.500528 7.73184 1.01614 8.62649 1.9393C9.37785 2.7146 10.6216 2.7146 11.373 1.9393Z",
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_1895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.90625 6.1875) rotate(58.6809) scale(13.8273 18.1071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF6D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D14933"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.28101f0b56bf9252416b441e3129da50.svg";
export { ForwardRef as ReactComponent };